import { render } from "./BaseImageMessage.vue?vue&type=template&id=49a4e79c"
import script from "./BaseImageMessage.vue?vue&type=script&lang=js"
export * from "./BaseImageMessage.vue?vue&type=script&lang=js"

import "./BaseImageMessage.vue?vue&type=style&index=0&id=49a4e79c&lang=css"

import exportComponent from "/mnt/jenkins/workspace/taoziprod-platform-webh5-remoteinquiry-master-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__